import { View, Text } from 'react-native';
import gs from '../../../styles/globalStyles';
import classes from '../../../styles/globalClasses';
import NeedHelp from '../../../sharedComponents/NeedHelp/NeedHelp';
import BackButton from '../../../sharedComponents/BackButton/BackButton';
import { PrivateStackParamList } from '../../../navigationApp/types';
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack';


type NavigationProp = NativeStackNavigationProp<
  PrivateStackParamList,
  'INTEREST_CALCULATOR'
>;

const InterestCalculatorHeader = ({ navigation } :  { navigation : NavigationProp} ) => {
  return (
    <View
      style={[
        gs.flexRow,
        gs.spaceBetween,
        gs.setBg('#fff'),
        gs.setPaddingHorizontal(16),
        gs.setHeight(60),
        gs.alignItemsCenter,
        {
          borderBottomColor:'#e4e7ec',
          borderBottomWidth:1,
        }
      ]}>
      <View style={[gs.flexRow]}>
        <BackButton navigation={navigation} />
      </View>
      <NeedHelp />
    </View>
  );
};

export default InterestCalculatorHeader;
